var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEzLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1527.51 497.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#303b93;}.cls-2,.cls-3{stroke:#303b93;stroke-miterlimit:10;}.cls-2{stroke-width:7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.2,127.2H152.8a6.31,6.31,0,0,1-6.4-6.4c0-4,2.4-6.4,6.4-6.4H359.2a6.4,6.4,0,1,1,0,12.8Z",
    transform: "translate(-7.2 -7.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.8,364.8a6.31,6.31,0,0,1-6.4-6.4V152.8a6.31,6.31,0,0,1,6.4-6.4c4,0,6.4,2.4,6.4,6.4V359.2C127.2,362.4,124,364.8,120.8,364.8Z",
    transform: "translate(-7.2 -7.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.2,396.8H152.8a6.31,6.31,0,0,1-6.4-6.4c0-4,2.4-6.4,6.4-6.4H359.2a6.4,6.4,0,1,1,0,12.8Z",
    transform: "translate(-7.2 -7.2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.2,364.8a6.31,6.31,0,0,1-6.4-6.4V152.8a6.31,6.31,0,0,1,6.4-6.4c4,0,6.4,2.4,6.4,6.4V359.2C396.8,362.4,394.4,364.8,391.2,364.8Z",
    transform: "translate(-7.2 -7.2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.8,239.2a6.11,6.11,0,0,1-4-1.6L274.4,91.2a6.22,6.22,0,1,1,8.8-8.8L429.6,228.8a6.28,6.28,0,0,1,0,8.8C428,239.2,426.4,239.2,424.8,239.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.2,239.2a6.11,6.11,0,0,1-4-1.6,6.28,6.28,0,0,1,0-8.8L229.6,82.4a6.22,6.22,0,0,1,8.8,8.8L91.2,237.6A4.4,4.4,0,0,1,87.2,239.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.6,431.2a6.11,6.11,0,0,1-4-1.6L82.4,282.4a6.22,6.22,0,0,1,8.8-8.8L237.6,420a6.28,6.28,0,0,1,0,8.8A4.4,4.4,0,0,1,233.6,431.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.4,431.2a6.11,6.11,0,0,1-4-1.6,6.28,6.28,0,0,1,0-8.8L420.8,274.4a6.22,6.22,0,1,1,8.8,8.8L282.4,429.6a6.11,6.11,0,0,1-4,1.6Z",
    transform: "translate(-7.2 -7.2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,504.8a46.4,46.4,0,1,1,46.4-46.4A46.43,46.43,0,0,1,256,504.8Zm0-80.8a34.4,34.4,0,1,0,34.4,34.4A34.15,34.15,0,0,0,256,424Z",
    transform: "translate(-7.2 -7.2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,100a46.4,46.4,0,1,1,46.4-46.4A46.43,46.43,0,0,1,256,100Zm0-80.8a34.4,34.4,0,1,0,34.4,34.4A34.15,34.15,0,0,0,256,19.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458.4,302.4A46.4,46.4,0,1,1,504.8,256,46.43,46.43,0,0,1,458.4,302.4Zm0-80.8A34.4,34.4,0,1,0,492.8,256a34.15,34.15,0,0,0-34.4-34.4Z",
    transform: "translate(-7.2 -7.2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.6,302.4A46.4,46.4,0,1,1,100,256,46.43,46.43,0,0,1,53.6,302.4Zm0-80.8A34.4,34.4,0,1,0,88,256a34.15,34.15,0,0,0-34.4-34.4Z",
    transform: "translate(-7.2 -7.2)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.6,444.8A46.4,46.4,0,1,1,160,398.4,46.43,46.43,0,0,1,113.6,444.8Zm0-80.8A34.4,34.4,0,1,0,148,398.4C148,380,132,364,113.6,364Z",
    transform: "translate(-7.2 -7.2)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.4,160a46.4,46.4,0,1,1,46.4-46.4A46.43,46.43,0,0,1,398.4,160Zm0-80.8a34.4,34.4,0,1,0,34.4,34.4A34.15,34.15,0,0,0,398.4,79.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.4,444.8a46.4,46.4,0,1,1,46.4-46.4A46.43,46.43,0,0,1,398.4,444.8Zm0-80.8a34.4,34.4,0,1,0,34.4,34.4A34.66,34.66,0,0,0,398.4,364Z",
    transform: "translate(-7.2 -7.2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.6,160A46.4,46.4,0,1,1,160,113.6,46.43,46.43,0,0,1,113.6,160Zm0-80.8A34.4,34.4,0,1,0,148,113.6,34.66,34.66,0,0,0,113.6,79.2Z",
    transform: "translate(-7.2 -7.2)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.9,258.66c0-56,45.68-101.48,101.84-101.48a102.09,102.09,0,0,1,62.55,21.4l-15,0a2.67,2.67,0,1,0,0,5.34h0l22.38,0a2.66,2.66,0,0,0,2.67-2.66l.05-22.39a2.66,2.66,0,0,0-2.67-2.67h0a2.68,2.68,0,0,0-2.68,2.66l0,16.7a107.46,107.46,0,0,0-67.3-23.7c-59.11,0-107.2,47.92-107.2,106.82a106,106,0,0,0,18.31,59.73,2.68,2.68,0,0,0,3.72.72,2.66,2.66,0,0,0,.72-3.71A100.69,100.69,0,0,1,153.9,258.66Z",
    transform: "translate(-7.2 -7.2)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M340.91,198.22a2.65,2.65,0,0,0-.72,3.7,100.82,100.82,0,0,1,17.39,56.74c0,56-45.69,101.49-101.84,101.49a101.76,101.76,0,0,1-64.42-22.9l15.52,0a2.67,2.67,0,1,0,0-5.34h0l-22.38,0a2.68,2.68,0,0,0-2.68,2.67L181.72,357a2.68,2.68,0,0,0,2.68,2.67h0a2.67,2.67,0,0,0,2.68-2.66l0-16.26a107.18,107.18,0,0,0,68.62,24.76c59.11,0,107.2-47.92,107.2-106.83a106,106,0,0,0-18.31-59.73A2.68,2.68,0,0,0,340.91,198.22Z",
    transform: "translate(-7.2 -7.2)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M257.79,287.29h56.36a3.51,3.51,0,0,1,3.51,3.51v14.09a3.51,3.51,0,0,1-3.51,3.51H257.79a3.51,3.51,0,0,1-3.51-3.51V290.8a3.51,3.51,0,0,1,3.51-3.51Z",
    transform: "translate(-7.2 -7.2)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201,279.36,238.4,242l14.92,14.92-37.39,37.4A10.55,10.55,0,0,1,201,279.36Z",
    transform: "translate(-7.2 -7.2)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.35,232l24.89-24.89L288.16,232l-24.88,24.88Z",
    transform: "translate(-7.2 -7.2)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.6,234.5l5,5a3.51,3.51,0,0,1,0,5l-29.9,29.89a3.5,3.5,0,0,1-5,0l-5-5a3.51,3.51,0,0,1,0-5l29.89-29.89a3.51,3.51,0,0,1,5,0Z",
    transform: "translate(-7.2 -7.2)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.89,229.53a3.51,3.51,0,0,1-5,0l-5-5a3.51,3.51,0,0,1,0-5l29.89-29.89a3.51,3.51,0,0,1,5,0l5,5a3.51,3.51,0,0,1,0,5Z",
    transform: "translate(-7.2 -7.2)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.66,232V110.66h65.43v16.23H551.37v35.75h47.72v16.24H551.37v36.9h47.72V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.73,232V182.65c0-7.05,0-28.37-22.63-28.37-14.27,0-24,10-24,28.21V232h-17V141.16H635v9.68h.32c9.19-12.14,23-12.14,26.57-12.14,14.11,0,25.59,6.07,32.15,16.24,3.61,5.9,5.57,13.12,5.74,23.28V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M722.09,232V156.74h-8V141.16h8v-4.43c0-9.67,3.77-16.4,10.82-21.15,7.38-4.43,12.14-4.92,22.14-4.92v15.58c-11.31,0-15.9,4.1-15.9,10.49v4.43h15.9v15.58h-15.9V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M808,234.31c-30.51,0-49-25.42-49-48.38,0-24.76,20.83-47.23,49-47.23,27.55,0,49,21.65,49,47.56C857.06,208.4,838.86,234.31,808,234.31Zm0-80c-19.19,0-32,15.91-32,32.14,0,16.4,13,32.31,32,32.31,18.36,0,32-15.25,32-32.47C840,170.19,827.21,154.28,808,154.28Z",
    transform: "translate(-7.2 -7.2)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M874.44,232V141.16h15.91v8.2h.33c7.22-10.17,18.86-10.5,23.12-10.66v17.55a32.1,32.1,0,0,0-12.3,3.28c-5.41,2.95-10,9.84-10,22.79V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M993.51,171.34c-2.79-5.74-9.35-17.06-25.58-17.06-22,0-29.85,18.37-29.85,32.14,0,15.75,10,32.31,29.52,32.31,12.79,0,21.48-7.38,25.75-16.73h19c-6.89,20.18-24.6,32.31-44.77,32.31-29.85,0-46.58-24.43-46.58-47.89,0-24.6,18-47.72,46.74-47.72,25.75,0,41.17,19.19,44.61,32.64Z",
    transform: "translate(-7.2 -7.2)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1041.07,194c4.26,17.55,18.37,24.76,29.85,24.76a29.05,29.05,0,0,0,25.91-15.25h17.05c-8.69,23.45-29.51,30.83-43.62,30.83-25.75,0-46.25-22.14-46.25-47.89,0-27.22,21-47.72,46.58-47.72a46.58,46.58,0,0,1,46.25,46.58c0,2.95-.33,7.54-.5,8.69Zm58.71-13.12c-.82-13.29-13-26.57-29.36-26.57s-28.53,13.28-29.35,26.57Z",
    transform: "translate(-7.2 -7.2)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1254.27,232V181.5c0-7.7-1-27.22-21.48-27.22-21.82,0-21.49,19.52-21.65,27.06V232h-17.06V181.5c.17-7.54-.16-12.62-3.77-18.69-4.27-6.56-10.66-8.53-16.89-8.53-22.47,0-22.47,20.34-22.47,27.06V232h-17.06V141.16h15.75V151h.32c3.28-3.77,9.19-12.3,26.08-12.3,11,0,23.62,5.25,28.21,15.25,3-4.59,9.67-15.25,30-15.25,15.25,0,26.08,6.23,32,16.4,3.28,5.9,5.09,13.28,5.09,22.14V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1305.6,194c4.26,17.55,18.37,24.76,29.85,24.76a29,29,0,0,0,25.91-15.25h17.06c-8.7,23.45-29.52,30.83-43.63,30.83-25.75,0-46.25-22.14-46.25-47.89,0-27.22,21-47.72,46.58-47.72a46.58,46.58,0,0,1,46.25,46.58c0,2.95-.33,7.54-.49,8.69Zm58.71-13.12c-.82-13.29-13-26.57-29.35-26.57s-28.54,13.28-29.36,26.57Z",
    transform: "translate(-7.2 -7.2)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1461.89,232V182.65c0-7.05,0-28.37-22.63-28.37-14.27,0-24,10-24,28.21V232h-17V141.16h15.91v9.68h.33c9.18-12.14,23-12.14,26.56-12.14,14.11,0,25.59,6.07,32.15,16.24,3.61,5.9,5.57,13.12,5.74,23.28V232Z",
    transform: "translate(-7.2 -7.2)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1519.78,232h-17V156.74h-12.3V141.16h12.3v-30.5h17v30.5h14.93v15.58h-14.93Z",
    transform: "translate(-7.2 -7.2)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M523.65,401V384.78l52.65-88.89H526.44V279.66h69.7v16.23l-52.31,88.89h54.44V401Z",
    transform: "translate(-7.2 -7.2)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654,403.31c-30.5,0-49-25.42-49-48.38,0-24.76,20.82-47.23,49-47.23,27.55,0,49,21.65,49,47.56C703.07,377.4,684.86,403.31,654,403.31Zm0-80c-19.19,0-32,15.91-32,32.14,0,16.41,13,32.31,32,32.31,18.37,0,32-15.25,32-32.47C686,339.19,673.22,323.28,654,323.28Z",
    transform: "translate(-7.2 -7.2)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M783.92,401V351.65c0-7,0-28.37-22.63-28.37-14.27,0-23.95,10-23.95,28.21V401H720.29V310.16h15.9v9.68h.33c9.19-12.14,23-12.14,26.57-12.14,14.1,0,25.58,6.07,32.14,16.24,3.61,5.9,5.58,13.12,5.74,23.29V401Z",
    transform: "translate(-7.2 -7.2)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.25,363c4.26,17.55,18.37,24.76,29.85,24.76A29.05,29.05,0,0,0,891,372.48h17c-8.69,23.45-29.52,30.83-43.62,30.83-25.75,0-46.25-22.14-46.25-47.89,0-27.22,21-47.72,46.58-47.72A46.58,46.58,0,0,1,911,354.28c0,3-.33,7.54-.5,8.69ZM894,349.85c-.82-13.28-13-26.57-29.36-26.57s-28.53,13.29-29.35,26.57Z",
    transform: "translate(-7.2 -7.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzLogo);
export default __webpack_public_path__ + "static/media/ez-logo.3ed3ac8ba204db6f97cac56ef006df84.svg";
export { ForwardRef as ReactComponent };